<template>
    <div class="view-nugget-detail">

        <page-header
            :back-button="{
                link: () => $router.push({ name: 'learning-companion' }),
                label: t('overview'),
                icon: 'overview'
            }"></page-header>

        <div class="section-dimensioning section-dimensioning--large content-dimensioning">
            <template  v-for="(section, index) in getSections">
                <base-section
                    :key="`nugget-section-${index}`"
                    :section="section">
                </base-section>
            </template>
        </div>

        <recommendations-component
            v-if="getRecommendations"
            :recommendations="getRecommendations" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    UITEXTS_FETCH_NS,
    NUGGET_FETCH_NS,
    NUGGET_SET_NS
} from "@/store/actions.type";

import PageHeader from '@/components/common/PageHeader.vue';
import NuggetComponent from '@/components/NuggetComponent.vue';
import BaseSection from '@/components/sections/BaseSection.vue';
import RecommendationsComponent from '@/components/RecommendationsComponent.vue';

export default {
    name: 'NuggetDetail',

    components: {
        PageHeader,
        NuggetComponent,
        BaseSection,
        RecommendationsComponent,
    },

    props: {
        content: Object
    },

    computed: {
        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't',
        }),

        ...mapGetters('nugget', {
            getSections: 'getSections',
            getTopics: 'getTopics',
            getCategories: 'getCategories',
            getRecommendations: 'getRecommendations',
            getMeta: 'getMeta',
            isLoadingNugget: 'isLoading',
        }),

        isLoading() {
            return this.isLoadingUiTexts || this.isLoadingNugget;
        }
    },

    async beforeRouteEnter(to, from, next) {

        const [ uitextResult, nuggetResult ] = await Promise.all([
            await store.dispatch(UITEXTS_FETCH_NS),
            await store.dispatch(NUGGET_FETCH_NS, to.params.slug)
        ]);

        return next();
    },

    async beforeRouteUpdate(to, from, next) {

        await store.dispatch(NUGGET_FETCH_NS, to.params.slug);

        return next();
    },

    async created() {
        if (this.content) {
            store.dispatch(NUGGET_SET_NS, this.content);
            await store.dispatch(UITEXTS_FETCH_NS);
        }

        if (this.getMeta) {
            const { headline, subline } = this.getMeta;
            document.title = `SEAT - ${headline || subline || ''}` ;
        }
    },

    mounted() {
    }
}
</script>
